import type { Result } from '@/stores/type/result.type'
import type { ResultWithPhases } from '@/views/calculations/type/resultView.type'
import type {
  ChartConfiguration,
  RowOverrideByQuantityBlock
} from '@/stores/type/chartConfiguration.type'
import { RESULT_PHASE_KEYS } from '@/constants/lifecyclePhases'
import { toAmount } from '@/views/calculations/utils/resultChart/format'

export const applyRowOverrides = (
  results: Result[],
  config: ChartConfiguration | null
): Result[] => {
  const overrides = config?.row_overrides ?? []
  if (!overrides.length) return results
  const byQbb: RowOverrideByQuantityBlock = {}
  for (const override of overrides) {
    byQbb[override.quantity_building_block] = override
  }
  return results.map((result) => {
    const override = byQbb[result.quantity_building_block]
    if (!override) return result
    return {
      ...result,
      material_display_name: override.display_name ?? result.material_display_name,
      quantity_labels: override.labels ?? result.quantity_labels
    }
  })
}

export const aggregateResultsForTooltip = (results: ResultWithPhases[]): Result | undefined => {
  if (results.length === 0) return undefined
  if (results.length === 1) return results[0]
  const aggregatedResult: ResultWithPhases = { ...results[0] }
  for (let resultIndex = 1; resultIndex < results.length; resultIndex++) {
    const result = results[resultIndex]
    for (const key of RESULT_PHASE_KEYS) {
      aggregatedResult[key] = toAmount(aggregatedResult[key]) + toAmount(result[key])
    }
    aggregatedResult.total = toAmount(aggregatedResult.total) + toAmount(result.total)
    aggregatedResult.building = toAmount(aggregatedResult.building) + toAmount(result.building)
    aggregatedResult.use_maintenance =
      toAmount(aggregatedResult.use_maintenance) + toAmount(result.use_maintenance)
    aggregatedResult.demolition_processing =
      toAmount(aggregatedResult.demolition_processing) + toAmount(result.demolition_processing)
  }
  return aggregatedResult
}
